import React, { useContext, useState } from 'react';
import { Menu, type MenuProps, theme } from 'antd';
import Sider from 'antd/es/layout/Sider';
import { TiDocumentText } from 'react-icons/ti';
import { BarChartOutlined } from '@ant-design/icons';
import { IoPeopleOutline } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { AuthContext } from '../../../../config/AuthContext';

interface Props {
    setPantalla: (value: number) => void;
    initialPantalla: number;
}

const AppSiderPildoresId = (props: Props) => {
    const [pantalla, setPantalla] = useState(props.initialPantalla);
    const { user } = useContext(AuthContext);
    const navigate = useNavigate();
    const isAdmin = user && (user.tipus === '0' || user.tipus === '1');

    const { token: { colorBgContainer } } = theme.useToken();

    const baseItems: MenuProps['items'] = [
        {
            key: 'back',
            icon: <FaArrowLeft />,
            label: 'Tornar enrere',
            onClick: () => navigate('/jutge/pildores')
        },
        {
            type: 'divider'
        }
    ];

    const itemsStudent: MenuProps['items'] = [
        ...baseItems,
        {
            key: '1',
            icon: React.createElement(TiDocumentText),
            label: 'Píldores',
            onClick: () => { setPantalla(0); props.setPantalla(0); }
        }
    ];

    const itemsAdmin: MenuProps['items'] = [
        ...baseItems,
        {
            key: '1',
            icon: React.createElement(TiDocumentText),
            label: 'Píldores',
            onClick: () => { setPantalla(0); props.setPantalla(0); }
        },
        {
            key: '2',
            icon: React.createElement(BarChartOutlined),
            label: 'Estadístiques',
            onClick: () => { setPantalla(1); props.setPantalla(1); }
        }
    ];

    return (
        <Sider style={{ background: colorBgContainer }} width={200}>
            <Menu
                mode="inline"
                defaultSelectedKeys={[(pantalla + 1) + '']}
                defaultOpenKeys={['sub1']}
                style={{ height: '100%' }}
                items={isAdmin ? itemsAdmin : itemsStudent}
            />
        </Sider>
    );
};

export default AppSiderPildoresId;
